import React, { useState } from 'react';
import { FaUser } from "react-icons/fa";
import { IoSearch, IoClose, IoCaretDownSharp } from "react-icons/io5";
import { LuMenu } from "react-icons/lu";
import { GoSquareFill } from "react-icons/go";
import { Row, Col } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';
import { Sidebar } from '../../components/common'
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { NavDropdown } from 'react-bootstrap';
import { FaInstagramSquare } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa6";
import { useDispatch } from 'react-redux';
import useApidata from '../../hooks/useApidata';
const Header = () => {
    const head = ["home", "news", "earth", "real", "sports", "worklife",]
    const dispatch = useDispatch();
    const navdata = useSelector(state => state.masterdata.navdata);
    const [selectedOption, setSelectedOption] = useState(null);
    const langdata = useSelector(state => state.masterdata.langdata);
    const slectedkeys = useSelector(state => state.masterdata.slectedkeys);

    const keysdata = langdata && langdata[0]
        ? Object.keys(langdata[0])
        : [];
    const [data, setData] = useState(false);
    const ismobile = useMediaQuery({ query: '(min-width: 991px)' })
    const Handle = () => {
        setData(!data)
    }
    const {useCategoryData} = useApidata()
    const {data:ndata, isLoading} = useCategoryData()
    const navdata1= ndata?.data?.data?.filters?.categories
    console.log("navdata", ndata?.data?.data?.filters?.categories?.map(i=>(
        i.label
    )))
    const [dataindex, setDataindex] = useState(0);
    const Clicks = (navigation_id) => {
        setDataindex(navigation_id)

    }
    const clicked = (data) => {
        // alert(data)
        dispatch({
            type: 'setslectedkeys',
            payload: data

        });
        setSelectedOption(data);
    }


    return (
        <div className='main-header'>
            <div className='header-main-div-company'>

                {
                    !ismobile ?

                        <>
                            <div className='header-logo'>

                                <NavLink className={"text-decoration-none"} to="/">
                                    <img referrerPolicy="no-referrer" className='header-logo-image' src={'/drpujitha_logo.webp'}></img>
                                </NavLink>

                            </div>
                            <div className='header-main'>
                                <div className='header-name'>
                                    Dr.Pujitha Devi Suraneni
                                </div>
                                <div className='header-colification'>MBBS,MS(Obs & Gynae),FMAS,FICRS</div>
                                <div className='headcontant'>Senior consultant,High-Risk Obstetrician,</div>
                                <div className='headcontant'>Laparoscopic and Robotic Surgeon</div>
                            </div>
                        </> :
                        <>
                            <Col lg={4} className='header-main  heder-contentent-header '>
                                <div className='header-name'>
                                    Dr.Pujitha Devi Suraneni
                                </div>
                                <div className='header-colification'>MBBS,MS(Obs & Gynae),FMAS,FICRS</div>
                                <div className='headcontant'>Senior consultant,High-Risk Obstetrician,</div>
                                <div className='headcontant'>Laparoscopic and Robotic Surgeon</div>
                            </Col>

                            <Col lg={4} className='header-logo  heder-contentent-logo'>

                                <NavLink className={"text-decoration-none"} to="/">
                                    <img referrerPolicy="no-referrer" className='header-logo-image' src={'/drpujitha_logo.webp'}></img>
                                </NavLink>

                            </Col >
                            <Col lg={4} className='header-contact-logolist'>
                                <NavLink className={"text-decoration-none"} to="https://www.instagram.com/drpujithadevisuraneni/" target="_blank">
                                    <FaInstagramSquare className='header-contact-logo' />
                                </NavLink>
                                <NavLink className={"text-decoration-none"} to="https://www.facebook.com/DrPujithaDeviSuraneni" target="_blank">
                                    <FaFacebook className='header-contact-logo' />
                                </NavLink>
                                <NavLink className={"text-decoration-none"} to="https://www.youtube.com/@PujithaDeviSuraneni" target="_blank">
                                    <FaYoutube className='header-contact-logo' />
                                </NavLink>
                            </Col>

                        </>

                }






                {/* <div>

     </div> */}
            </div>



            <div className='header-below'>
                {/* <div className='header-below-title'>NEWS</div> */}
                {
                    ismobile ?
                        <div className='header-below-list'>
                            {/* <NavLink  className={"text-decoration-none"}  to="/">
                                <span
                                    className={`header-below-list-items  ${dataindex === 0 ? 'active' : ''
                                        }`}
                                    onClick={() => {
                                        Clicks(0);
                                    }}
                                >
                                    <span className='ftdfdf'></span>
                                   
                                    {/* {slectedkeys != '' && (langdata.length > 0) ? (
                                        langdata
                                            .filter(comp => comp.KEYS === "header_navlink_name1")
                                            .map(translatedData => (
                                    
                                                        <span key={translatedData.id}>
                                                            {translatedData[slectedkeys]}
                                                        </span>
                                                       
                                            ))
                                    ) : "Home"

                    } */}
                            {/* </span> */}
                            {/* </NavLink> */}

                            <div className='dgfdh'>





                                {navdata1?.map((ele, index) => (

                                    <div key={ele.navigation_id}>
                                        <NavLink className={"text-decoration-none"} to={`/Category/${ele.maincategory_id}`}>
                                            <span
                                                className={`header-below-list-items ${dataindex === ele.label ? 'active' : 'disable'
                                                    }`}
                                                onClick={() => {
                                                    Clicks(ele.label);
                                                }}
                                            >
                                                <span className='ftdfdf'></span> {ele.label} 
                                            </span>
                                        </NavLink>
                                    </div>
                                ))}


                            </div>

                            {/* <span className='header-below-list-items header-below-list-more'> more <IoCaretDownSharp  /></span> */}
                        </div>
                        : <div ><Sidebar /></div>
                }

            </div>

        </div >
    );
};

export default Header;